import { toTitleCase } from '../formatCustomerData';
import type { EnrichedOrderHistory } from '../../services/react-query/query/orders/types';

export const mapOrderToProduct = <T = Record<string, any>>(
  order: EnrichedOrderHistory,
  overrides?: Partial<T>
): T =>
  ({
    active: order?.product?.active ?? true,
    discontinued: order?.product?.discontinued || false,
    categories: [],
    created_on: '',
    description: '',
    dropship: false,
    inventory: order.product.inventory || [],
    last_modified: '',
    manufacturerProductNumber: '',
    packSize: '',
    procurementStopped: false,
    productCode: '',
    promotions: [],
    salesStopped: false,
    stockInfo: null,
    special: false,
    unit: '',
    updated_on: '',
    vendor: order.product.vendor,
    custom: null,
    privateLabel: false,
    productAssociations: [],
    images: [],
    // eslint-disable-next-line no-underscore-dangle
    _id: order.product._id,
    sku: order.product.sku,
    quantity: undefined,
    price: null,
    cost: order.cost,
    sell: order.sell,
    profitMarginCurrency: order.sell - order.cost || 0,
    profitMarginPercent: order.sell
      ? parseFloat((((order.sell - order.cost) / order.sell) * 100).toFixed(2))
      : 0,
    manufacturerSku: order.product.manufacturerSku,
    imageUrl:
      (typeof order.product.images?.[0] === 'string'
        ? order.product.images[0]
        : (order.product.images?.[0] as any)?.path) || '',
    name: toTitleCase(order.product.name),
    needsPriceUpdate: false,
    loading: false,
    isEditable: false,
    createdDate: order.createdDate,
    lastSoldQuantity: order.quantity,
    ...(overrides || {})
  }) as T;
